import { User } from "oidc-client";
import { ajax, AjaxError, AjaxResponse } from "rxjs/ajax";
import { Observable } from "rxjs";
import AjaxHelper from "./AjaxHelper";
import { ICommunicationPayload } from "../../DataClasses/CommunicationData";

class CommunicationsService {
    public static GetCommunications$(user: User): Observable<ICommunicationPayload[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Communications/GetCommunications',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static GetCommunicationsDetail$(user: User): Observable<ICommunicationPayload[]> {
        return AjaxHelper.AjaxGet$(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Communications/GetCommunicationsDetail',
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static SaveCommunication$(user: User, id: number, base64Pdf: string, displayOrder: string, title: string): Observable<AjaxResponse<any> | AjaxError> {
        return ajax.post(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Communications/SaveCommunication',
            {
                id: id,
                displayOrder: displayOrder,
                base64Pdf: base64Pdf,
                title: title
            },
            AjaxHelper.CreateHttpHeaders(user)
        )
    }

    public static DeleteCommunication$(user: User, id: number): Observable<AjaxResponse<any> | AjaxError> {
        return AjaxHelper.AjaxPost(
            process.env.REACT_APP_MYWEBSITE_BASESERVICEURL + '/api/Communications/DeleteCommunication?id=' + id,
            {},
            AjaxHelper.CreateHttpHeaders(user)
        )
    }
}

export default CommunicationsService;
